import { Component, forwardRef, Fragment } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../utils/pagination";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../actions/fillCombo_action';
import AdminDrawer from "../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import { getAccountExitPassList_action, insertExitPassOTP_action, getDamageDetails_action, insertDamage_action, getExitPassPdf_action, verifyExitPassOTP_action, updateDamageApproveStatus_action, dismantleStallHM_action } from "../../../actions/admin_module_action/account_exit_pass_action/account_exit_pass_action";
import { exhibitionId, serviceTypeId, toastError, DOC_BASE_URL, toastSuccess, contractorListActionId, HallZoneActionId, downloadReport, fetchAuthReport, HallListActionId, HallZoneListActionId } from "../../../utils/constants";
import Select from 'react-select';
import Modal from "react-modal";
import { data } from "jquery";
// import 'bootstrap-icons/font/bootstrap-icons.css';
import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import moment from "moment";
import ImageCapture from '../../../utils/ImageCapture';
import Resizer from "react-image-file-resizer";
import ConfirmationModal from "../../../common_components/confirmationa_modal";


class AccountExitPassList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            QrCodeImg: '',
            accountExitPassList: [],
            contractorList: [],
            hallList: [],
            zoneList: [],
            currentPage: 1,
            ExitNo: '',
            HallId: '',
            ZoneId: '',
            ExhRegistrationNo: '',
            CompanyName: '',
            ContractorCompanyName: '',
            DmgCompanyName: '',
            pendingCount: '',
            approvedCount: '',
            saveAsDraftCount: '',
            rejectedCount: '',

            isLastExitPassPop: false,
            damagePop: false,
            damageRemark: '',
            remarkErr: '',
            damageDocPath1: '',
            damageDocName1: '',
            damageDocFile1: '',
            damageDocType1: '',
            confirmationObj: { message: '', buttonName: '', action: '' },
            popArg: [],
            isOpenConfirmationModal: false,

            damageDocPath2: '',
            damageDocName2: '',
            damageDocFile2: '',
            damageDocType2: '',

            damageDocPath3: '',
            damageDocName3: '',
            damageDocFile3: '',
            damageDocType3: '',

            damageDocErr: '',
            isImageModal: false,

            imgarr: [],
            damagePop2: false,
            exhNo: '',
            exhname: '',
            damageMarked: '',
            DamageDate: '',
            mailData: {},

            NDRpop: false,
            NDR: '',
            DamageStatusPop: false,
            ExhExitPassHdrID: null,
            DamageStatusID: null,
            DamageApprovedRemark: null,
            DamageApprovedRemarkErr: '',
            statusList: [],
            tcomp: '',
            tpending: '',
            dismantlePop: false,
            mainList: [],
            isHallManager: sessionStorage.getItem("RoleIDSS") == 16,
            IsDismantledPopDisable: false,
            loginAccesslist: [],
            // null = no dismantle filter, 0 = pending for dismantle, 1 = dismantled.
            // Kept in state so a background refresh can re-apply the user's view
            dismantleFilter: null
        }
        this.getAccountExitPassList = this.getAccountExitPassList.bind(this)
        this.renderList = this.renderList.bind(this)
        this.updateItem = this.updateItem.bind(this)
        this.onViewExitPass = this.onViewExitPass.bind(this)
        this.clearValue = this.clearValue.bind(this)
        this.onPassDownload = this.onPassDownload.bind(this)
        this.onPassPrint = this.onPassPrint.bind(this)

        this.handleConfirmation = this.handleConfirmation.bind(this)
        this.pollingTimer = null
        // Criteria of the last executed search, replayed by the background refresh so it
        // can't pick up filter edits the user hasn't hit Search on yet
        this.lastListArgs = null
        this.lastCountArgs = null
    }


    handleConfirmation(flag) {
        const { confirmationObj, popArg } = this.state;
        if (flag) {
            if (confirmationObj.action == 0) {
                this.onPassDownload(popArg[0])
            }
            if (confirmationObj.action == 1) {
                this.onPassPrint(popArg[0])
            }
        }
        this.setState({ isOpenConfirmationModal: false })
    }

    componentDidMount() {
        this.setState({ loginAccesslist: JSON.parse(sessionStorage.getItem('loginDataSS'))['loginAccesslist'] })
        this.getFillList(HallListActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '');
        this.getFillList(HallZoneListActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '');
        this.getFillList(contractorListActionId, '', '', '', '', '').then(() => {
            this.getDamageCountList(1, 1)
            this.getAccountExitPassList(1, 0)
            this.startPolling()
        })

    }

    componentWillUnmount() {
        this.stopPolling()
    }

    // Refresh the list every 15s in the background (no page reload, no loader flicker)
    startPolling() {
        this.stopPolling()
        this.pollingTimer = setInterval(() => {
            const { isOpen, damagePop, damagePop2, isLastExitPassPop, NDRpop, DamageStatusPop,
                dismantlePop, isImageModal, isOpenConfirmationModal, dismantleFilter } = this.state
            // The damage pop holds unsaved remarks and uploads, so never refresh under an open modal
            if (isOpen || damagePop || damagePop2 || isLastExitPassPop || NDRpop || DamageStatusPop ||
                dismantlePop || isImageModal || isOpenConfirmationModal || document.hidden) {
                return
            }
            // Always refresh the dismantle counts; when that filter is on, the grid is driven by
            // mainList so getDamageCountList repaints it and the list call would only fight with it
            this.getDamageCountList(1, 1, true)
            if (dismantleFilter == null) {
                this.getAccountExitPassList(null, null, true)
            }
        }, 15000)
    }

    stopPolling() {
        if (this.pollingTimer) {
            clearInterval(this.pollingTimer)
            this.pollingTimer = null
        }
    }

    // Same rule the Pending for Dismantle / Dismantled chips filter by
    filterByDismantleStatus(list, mode) {
        return list.filter(
            item => mode == 0 ? (item.IsDismantled == 0 || item.IsDismantled == null) : item.IsDismantled == 1
        )
    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID) {
        const { } = this.state
        return new Promise((resolve, reject) => {

            this.props
                .fill_action(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID)
                .then((data) => {
                    if (data.error != 1) {
                        // voucher list
                        if (actionID === HallListActionId) {
                            this.setState({ hallList: data.data })
                            resolve()

                        }
                        if (actionID === HallZoneListActionId) {
                            this.setState({ zoneList: data.data })
                            resolve()

                        }
                        if (actionID === contractorListActionId) {
                            const array = []
                            data.data.map((item, i) => {
                                array.push(item)
                            })
                            array.push({ ContractorID: 0, CompanyName: 'Other' })
                            this.setState({
                                contractorList: array,
                                //  isLoading: false,
                            }, () => {
                                resolve(array)
                            })
                        }
                    }
                })
        })
    }

    onFilterClick = (mode) => {

        this.setState({ isLoading: true });

        const templist = this.filterByDismantleStatus(this.state.mainList, mode);
        setTimeout(() => {
            this.setState({
                accountExitPassList: templist,
                dismantleFilter: mode,
                isLoading: false
            });
        }, 200);
    };

    getDamageDetails(exhid, venid, no, name, DamageMarkedBy, DamageDate, ExhExitPassHdrID) {
        const { isLoading, DDreturnListArr, hallList, zoneList, currentPage, HallId, ZoneId, ExhRegistrationNo, CompanyName, vendorName, DDno, DDdate } = this.state
        this.setState({ isLoading: true })
        this.props.getDamageDetails_action('', 3, exhid, venid, ExhExitPassHdrID)
            .then((data) => {
                if (data.error != 1) {
                    // this.setState({ damageList: data.data[0] })
                    var list = data.data[0]
                    var docList = []
                    for (var i = 0; i < list.length; i++) {
                        docList.push(`${DOC_BASE_URL + list[i].DocumentPath}`)
                    }
                    this.setState({
                        isLoading: false, damagePop2: true, exhNo: no, exhname: name ?? data.data[0][0].PersonName, damageRemark: data.data[0][0].Remark, imgarr: docList, damageMarked: DamageMarkedBy, DmgCompanyName: data.data[0][0].CompanyName,
                        DamageDate: DamageDate
                    })
                } else {
                    toastError('Something went wrong...')
                    this.setState({ isLoading: false })

                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    // isSilent = background poll: keep the loader hidden, replay the last search and don't
    // reset the page or toast transient errors
    getAccountExitPassList(DamageStatusID, IsAllRecord, isSilent = false) {
        const args = isSilent && this.lastListArgs
            ? this.lastListArgs
            : {
                ExitNo: this.state.ExitNo,
                HallId: this.state.HallId,
                ZoneId: this.state.ZoneId,
                ExhRegistrationNo: this.state.ExhRegistrationNo,
                CompanyName: this.state.CompanyName,
                ContractorCompanyName: this.state.ContractorCompanyName,
                DamageStatusID,
                IsAllRecord
            }
        this.lastListArgs = args

        if (!isSilent) this.setState({ isLoading: true })
        this.props.getAccountExitPassList_action(args.ExitNo, args.HallId, args.ZoneId, args.ExhRegistrationNo, args.CompanyName, args.ContractorCompanyName, args.DamageStatusID, args.IsAllRecord)
            .then((data) => {
                if (data.error != 1) {
                    const updateState = { accountExitPassList: data.data, statusList: data.statusList }
                    if (isSilent) {
                        // Stay on the current page unless the refreshed list no longer reaches it
                        const lastPage = Math.max(1, Math.ceil(data.data.length / 10))
                        if (this.state.currentPage > lastPage) {
                            updateState.currentPage = lastPage
                        }
                    } else {
                        // A search or status chip replaces the dismantle-filtered view
                        updateState.dismantleFilter = null
                    }
                    this.setState(updateState)
                    if (!isSilent) this.setState({ isLoading: false })
                } else {
                    if (!isSilent) {
                        toastError('Something went wrong...')
                        this.setState({ isLoading: false })
                    }
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    getDamageCountList(DamageStatusID, IsAllRecord, isSilent = false) {
        // The counts are totals fetched with the criteria in force at mount; reuse those on a
        // refresh so the chips don't silently start counting a narrower set
        const args = isSilent && this.lastCountArgs
            ? this.lastCountArgs
            : {
                ExitNo: this.state.ExitNo,
                HallId: this.state.HallId,
                ZoneId: this.state.ZoneId,
                ExhRegistrationNo: this.state.ExhRegistrationNo,
                CompanyName: this.state.CompanyName,
                ContractorCompanyName: this.state.ContractorCompanyName,
                DamageStatusID,
                IsAllRecord
            }
        this.lastCountArgs = args

        if (!isSilent) this.setState({ isLoading: true })
        this.props.getAccountExitPassList_action(args.ExitNo, args.HallId, args.ZoneId, args.ExhRegistrationNo, args.CompanyName, args.ContractorCompanyName, args.DamageStatusID, args.IsAllRecord)
            .then((data) => {
                if (data.error != 1) {
                    var temppemding = 0
                    var tempcomp = 0
                    // if (data.data[0].length > 0) {
                    data.data.map(item => {
                        if (item['IsDismantled'] == 1) {
                            tempcomp = tempcomp + 1
                        } else {
                            temppemding = temppemding + 1
                        }
                    })
                    const updateState = { tcomp: tempcomp, tpending: temppemding, mainList: data.data, }
                    // With a dismantle chip active the grid is a slice of mainList, so refresh it here
                    if (isSilent && this.state.dismantleFilter != null) {
                        const filtered = this.filterByDismantleStatus(data.data, this.state.dismantleFilter)
                        updateState.accountExitPassList = filtered
                        const lastPage = Math.max(1, Math.ceil(filtered.length / 10))
                        if (this.state.currentPage > lastPage) {
                            updateState.currentPage = lastPage
                        }
                    }
                    this.setState(updateState)
                    if (!isSilent) this.setState({ isLoading: false })
                } else {
                    if (!isSilent) {
                        toastError('Something went wrong...')
                        this.setState({ isLoading: false })
                    }
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    onFilterClick(mode) {
        const { isLoading, ExitNo, HallId, ZoneId, isOpen, mainList, QrCodeImg, ExhRegistrationNo, ContractorCompanyName, CompanyName, hallList, zoneList, accountExitPassList, currentPage, dismantlePop, tcomp, tpending } = this.state
        var templist
        if (mode == 0) {
            templist = mainList.filter(item => item['IsDismantled'] == 1)
        } else {
            templist = mainList.filter(item => item['IsDismantled'] != 1)
        }
        console.log("templist--->", templist)
        this.setState({ accountExitPassList: templist })
    }

    onViewExitPass(vendorID, ExhID, exitId, otherInfo, isVendor, ExitNo) {
        const { isLoading, HallId, ZoneId, ExhRegistrationNo, CompanyName, accountExitPassList } = this.state
        this.props.navigate('/exitPass', { state: { is_view: true, isExhibitor: vendorID == null ? true : false, regId: ExhID, vendorID: vendorID, exitId: exitId, otherInfo: vendorID == 0 ? otherInfo : null, isVendor: isVendor, ExitNo: ExitNo } })
    }


    onPassDownload(id) {
        console.log(id);
        this.setState({ isLoading: true });
        this.props
            .getExitPassPdf_action(id)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false });
                    console.log("Proforma Pdf Download", data);
                    var url = `${downloadReport}?SessionIdentifier=${data}&Export=true`;
                    const win = window.location.replace(url, "_blank");
                    if (win != null) {
                        win.focus();
                    }
                } else {
                    this.setState({ isLoading: false });
                    toastError(data.msg);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }
    async onPassPrint(id) {
        console.log(id);
        this.setState({ isLoading: true });
        try {
            var list = [];
            const mapdata1 = {
                ParameterName: "@ExhExitpassHdrID",
                ParameterValue: id,
                ParameterDataType: "int",
            };
            list.push(mapdata1);
            const mapData = {
                report_name: "ExitPass.rpt",
                parameter_details: list,
            };
            console.log("xxxxxxxxxxxxxxxxxxxxx", mapData);
            const res = await axiosPost(fetchAuthReport, mapData);
            this.setState({ isLoading: false });

            if (res != null) {
                var url = `${downloadReport}?SessionIdentifier=${res}`;
                const win = window.open(url, "_blank", "noopener,noreferrer");
                if (win != null) {
                    win.focus();
                }
            }
        } catch (err) {
            console.error(err);
        }
    }

    // Single source of truth for the Action column - the column header and the row icons are both
    // built from this list, so adding an action here is enough to get it into the header as well
    getRowActions() {
        return [
            {
                key: 'viewExitPass',
                label: 'View Material Exit pass',
                isVisible: (item) => true,
                render: (item) => (
                    <a style={{ cursor: 'pointer' }} class={'border-end'} onClick={() => this.onViewExitPass(item.VendorID, item.ExhRegistrationID, item.ExhExitPassHdrID,
                        {
                            companyName: item['Exhibitor Details'],
                            personName: item['Person Name'],
                            contactNo: item['Mobile Number'],
                            email: item['Email ID']
                        },
                        item.isVendor, item['Exit No']
                    )}>
                        <i class="bi bi-eye fs-6 grid-icon p-1 rounded-1 px-1 fw-normal" title="View Material Exit pass"></i>
                    </a>
                )
            },
            {
                key: 'download',
                label: 'Download',
                isVisible: (item) => item.StatusID != 4 && this.getDownloadAccess(),
                render: (item) => (
                    <i style={{ cursor: 'pointer' }} class="ri-download-line fs-6 grid-icon p-1 rounded-1 px-1 fw-normal border-end pe-1 me-1"
                        title="Download"
                        onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to Download?`, buttonName: "Download", action: 0 }, popArg: [item.ExhExitPassHdrID] })}></i>
                )
            },
            {
                key: 'print',
                label: 'Print',
                isVisible: (item) => item.StatusID != 4 && this.getDownloadAccess(),
                render: (item) => (
                    <i style={{ cursor: 'pointer' }} class="ri-printer-line fs-6 grid-icon p-1 rounded-1 px-1 fw-normal border-end pe-1 me-1"
                        title="Print"
                        onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to View?`, buttonName: "View", action: 1 }, popArg: [item.ExhExitPassHdrID] })}></i>
                )
            },
            {
                key: 'scanToPrint',
                label: 'Scan to Print',
                isVisible: (item) => item.StatusID != 4 && this.getSpecialAccess(),
                render: (item) => (
                    <a style={{ cursor: 'pointer' }} onClick={() => {
                        if (item.QRcodeImg) {
                            const byteArray = item.QRcodeImg.data || item.QRcodeImg;
                            const base64 = btoa(String.fromCharCode(...byteArray));
                            this.setState({ QrCodeImg: `data:image/png;base64,${base64}`, isOpen: true });
                        }
                    }}>
                        <i class={`fa fa-qrcode fs-6 grid-icon p-1 rounded-1 px-1 fw-normal qrIcon pe-2 me-1 border-end`} title="Scan to Print"></i>
                    </a>
                )
            },
            {
                // Same icon raises or reviews the damage depending on whether one is already marked
                key: 'damage',
                label: (item) => item.isDamaged ? "View Damage" : "Approve Damage",
                isVisible: (item) => item.DamageStatusID != null && item.DamageStatusID != 2 && this.getSpecialAccess(),
                render: (item) => (
                    <i style={{ cursor: 'pointer' }} class={item.isDamaged ? "bi bi-exclamation-triangle-fill text-aqua  p-1 border-end pe-2 me-1" : "fa fa-exclamation-triangle  p-1 rounded-1 px-1 fw-normal pe-2 me-1 grid-icon border-end"} onClick={() => item.isDamaged ? this.getDamageDetails(item['ExhRegistrationID'], item.VendorID, item.ExhRegistrationNo, item.ExhibitorName, item.DamageMarkedBy, item.DamageDate, item.ExhExitPassHdrID) : this.setState({ isLastExitPassPop: true, exhID: item.ExhRegistrationID, ExhExitPassHdrID: item.ExhExitPassHdrID, vendorId: item.VendorID, mailData: { ExitNo: item['Exit No'], PrimaryEmail: item.ExhRegistrationID != '' && item.ExhRegistrationID != null ? item.ExhEmail : item['Email ID'], person: item.ExhRegistrationID != '' && item.ExhRegistrationID != null ? item.ExhPersonName : item['Person Name'] } })} title={item.isDamaged ? "View Damage" : "Approve Damage"}></i>
                )
            },
            {
                key: 'approveDamage',
                label: 'Approve Damage',
                isVisible: (item) => item.DamageStatusID == 3,
                render: (item) => (
                    <i style={{ cursor: 'pointer' }}
                        onClick={() => this.setState({ DamageStatusPop: true, ExhExitPassHdrID: item.ExhExitPassHdrID, IsDismantledPopDisable: false })}
                        class="fa fa-check fs-6 grid-icon p-1 rounded-1 px-1 fw-normal pe-1 me-1 border-end" title="Approve Damage" aria-hidden="true"></i>
                )
            },
            {
                key: 'dismantle',
                label: 'Tag as Dismantled',
                isVisible: (item) => (this.state.isHallManager ? (item.DamageStatusID == 2 || item.DamageStatusID == 4) : true) && this.getSpecialAccess() && item['IsDismantled'] != 1,
                render: (item) => (
                    <i class="bi bi-tools fs-7 grid-icon p-1 rounded-1 px-1 fw-normal border-end" style={{ cursor: 'pointer' }} onClick={() => this.setState({ dismantlePop: true, exhID: item.ExhRegistrationID, ExhExitPassHdrID: item.ExhExitPassHdrID })} title="Tag as Dismantled"></i>
                )
            },
            {
                key: 'damageApprovedRemark',
                label: 'View Damage Approved Remark',
                isVisible: (item) => item['DamageStatusID'] == 4 && this.getSpecialAccess(),
                render: (item) => (
                    <i class="fa fa-commenting-o fs-7 grid-icon p-1 rounded-1 px-1 fw-normal border-end" style={{ cursor: 'pointer' }} onClick={() => this.setState({ DamageStatusPop: true, ExhExitPassHdrID: item.ExhExitPassHdrID, DamageApprovedRemark: item.DamageApprovedRemark, IsDismantledPopDisable: true })} title="View Damage Approved Remark"></i>
                )
            }
        ]
    }

    // Header text of the Action column - the tooltips of every icon visible on the current page,
    // de-duplicated so two icons sharing a tooltip are only named once
    buildActionHeader(actions, rows) {
        const labels = []
        actions.forEach((action) => {
            rows.forEach((item) => {
                if (!action.isVisible(item)) return
                const label = typeof action.label === 'function' ? action.label(item) : action.label
                if (label && !labels.includes(label)) labels.push(label)
            })
        })
        return labels.length > 0 ? labels.join('/') : 'Action'
    }

    renderList(currentRecords) {
        const { isLoading, ExitNo, HallId, ZoneId, ExhRegistrationNo, CompanyName, accountExitPassList } = this.state
        const rowActions = this.getRowActions()
        const actionHeader = this.buildActionHeader(rowActions, currentRecords)
        return (
            <>
                <table class="table sticky-table text-nowrap table-bordered mb-0">
                    <thead class="table-light">
                        <tr>
                            <th class="text-center" style={{ width: '250px' }}>Exit No</th>
                            <th class="text-center">Material Exit pass Date</th>
                            <th class="text-center">Hall</th>
                            <th class="text-center">Zone</th>
                            <th class="text-center">Stall</th>
                            <th>Exhibitor Details</th>
                            <th style={{ width: '250px' }}>Contractor/ Service Partner Details</th>
                            <th style={{ width: '70px' }}>No Dues Remark</th>
                            {/* <th class="text-center" style={{ width: '90px' }}>Material Exit pass Status</th> */}
                            <th class="text-center" style={{ width: '90px' }}>Damage Status</th>
                            <th class="text-center" style={{ width: '250px' }}>Dismantle Status</th>
                            <th class="text-center" style={{ width: '100px' }}>{actionHeader}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentRecords.length > 0 ? currentRecords.map(item => (
                            <tr>
                                {/* <td class="text-center">{item['Exit No'] || '-'}</td> */}
                                <td class="text-center">{item['Exit No'] != null && item['Exit No'] != '' ? item['Exit No'] : ''}</td>
                                <td class="text-center hall-td"> {item['ExitDate'] != null && item['ExitDate'] != '' ? moment(item['ExitDate']).format('DD/MM/YYYY') : '-'}</td>
                                <td class="text-center hall-td">{item['Hall'] || '-'}</td>
                                <td class="text-center">{item['Zone'] || '-'}</td>
                                <td class="text-center">{item['Stall'] || '-'}</td>
                                <td><span style={{ fontWeight: "600" }}>{item.isVendor == 0 && item['ExhRegistrationNo'] != null && item['ExhRegistrationNo'] != '' ? item['ExhRegistrationNo'] : ''}</span> {item.isVendor == 0 && item['ExhRegistrationNo'] != null && item['ExhRegistrationNo'] != '' ? <br /> : ''}{item.isVendor == 0 ? item['Exhibitor Details'] : '-'}</td>
                                <td class="vendor p-1 ">
                                    {item.VendorID != null ? <div style={{ lineHeight: '12px' }}>
                                        <span class="my-1 mt-0  ha-view-com"><i class="fa fa-solid grid-icon me-2 fa-building"></i>
                                            {item.ContractorCompanyName} </span>
                                        <br />
                                        {item['Person Name'] != null && <span class="mt-0  ha-view-com"><i class="ri-user-3-line grid-icon me-2"></i> {item['Person Name']} </span>}
                                        <br />
                                        {item['Mobile Number'] != null && <span class="mt-1"> <i class="ri-phone-line grid-icon me-2"></i>
                                            {item['Mobile Number']}  </span>}
                                        <br />
                                        {item['Email ID'] != null && <span> <i class="fa fa-solid grid-icon me-2 fa-envelope"></i>
                                            {item['Email ID']} </span>}
                                        <br />
                                    </div> : '-'}
                                </td>
                                <td style={{ color: '#3dbca7', textAlign: 'center' }}>{item.NoDuesRemark != '' && item.NoDuesRemark != null ? <i onClick={() => this.setState({ NDR: item.NoDuesRemark, NDRpop: true })} style={{ cursor: 'pointer' }} class="bi bi-info-circle"></i> : '-'}</td>
                                {/* <td class={item.ExitPassStatus == 'Rejected' ? "text-center text-danger" : item.ExitPassStatus == 'Approved' ? "text-center text-aqua" : 'text-center text-aqua'}>{item['ExitPassStatus']}</td> */}
                                <td class={item.DamageStatusID == 3 ? "text-left text-danger" : "text-left text-aqua"}>
                                    <i class={`${item.DamageStatusID == 1 ? "fa fa-hourglass-half" : item.DamageStatusID == 2 ? "bi bi-clipboard-check-fill" : item.DamageStatusID == 3 ? "bi bi-exclamation-triangle-fill" : item.DamageStatusID == 4 ? "fa fa-check-circle" : "fa fa-floppy-o"}  me-1 fs-6`}></i>&nbsp;
                                    {item['DamageName'] ? item['DamageName'] : "Save as Draft"}
                                </td>

                                <td class={'text-left text-aqua'}>
                                    <i class={`${item.IsDismantled == 1 ? "bi bi-tools" : "bi bi-clock"}  me-1 fs-6`}></i>&nbsp;
                                    {item['IsDismantled'] == 1 ? 'Dismantled' : 'Pending for Dismantle'}</td>

                                <td class="text-left act-col">
                                    {rowActions
                                        .filter((action) => action.isVisible(item))
                                        .map((action) => (
                                            <Fragment key={action.key}>{action.render(item)}</Fragment>
                                        ))}
                                </td>
                            </tr>
                        )) : <tr>
                            <td colSpan={12} className="text-center">Record not found</td>
                        </tr>}
                    </tbody>
                </table >
            </>
        )
    }

    // Update Current Page
    updateItem(item) {
        const { accountExitPassList } = this.state
        this.setState({ currentPage: item });
    }
    clearValue() {
        this.setState({
            ExitNo: '',
            HallId: '',
            ZoneId: '',
            ExhRegistrationNo: '',
            CompanyName: '',
            ContractorCompanyName: '',
        })
        setTimeout(() => {
            this.getAccountExitPassList(1, 0)
        }, 100);
    }
    handleCapture = (imageData) => {
        const { VendorIndex, camNp } = this.state
        if (camNp == 1) {
            this.setState({
                damageDocPath1: '',
                damageDocName1: 'Document1',
                damageDocFile1: imageData,
                damageDocType1: 'jpeg',
                damageDocErr: '',
            })
        }
        if (camNp == 2) {
            this.setState({
                damageDocPath2: '',
                damageDocName2: 'Document2',
                damageDocFile2: imageData,
                damageDocType2: 'jpeg',
                damageDocErr: '',
            })
        }
        if (camNp == 3) {
            this.setState({
                damageDocPath3: '',
                damageDocName3: 'Document3',
                damageDocFile3: imageData,
                damageDocType3: 'jpeg',
                damageDocErr: '',
            })
        }
        this.setState({ isImageModal: false })
    };



    renderNewImage = (img, type) => {
        const { imageBase64 } = this.state;
        if (type == 'pdf') {
            // window.open(img, "_blank")

            const base64 = img;
            const pdfData = atob(base64.split(",")[1]); // decode Base64

            const len = pdfData.length;
            const uintArray = new Uint8Array(new ArrayBuffer(len));
            for (let i = 0; i < len; i++) {
                uintArray[i] = pdfData.charCodeAt(i);
            }

            const blob = new Blob([uintArray], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);

            window.open(url, "_blank"); // open in new tab

        } else {
            const newWindow = window.open();
            if (newWindow) {
                newWindow.document.write(
                    `<img src="${img}" style="width:100%;height:auto;" />`
                );
            } else {
                alert("Please allow popups for this website");
            }
        }
    };


    onFilePick = async (e, file, num) => {
        e.preventDefault()
        const { } = this.state
        console.log('file', file)
        if (file.length != 0) {
            if (file[0]['size'] >= 5 * 1024 * 1024) {
                toastError('File size more than 5mb are not allow.')
            } else {
                var image = '';
                if (file[0]['name'].toString().toLowerCase().includes('.pdf') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
                    file[0]['name'].toString().toLowerCase().includes('.png') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpg')
                ) {
                    if (file[0]['name'].toString().toLowerCase().trim().includes('.jpg') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.png') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.jpeg')
                    ) {
                        if (num == 1) {
                            image = await this.resizeFile(file[0]);
                            this.setState({ damageDocFile1: image, damageDocName1: file[0]['name'].toString() })
                        } else if (num == 2) {
                            image = await this.resizeFile(file[0]);
                            this.setState({ damageDocFile2: image, damageDocName2: file[0]['name'].toString() })
                        } else if (num == 3) {
                            image = await this.resizeFile(file[0]);
                            this.setState({ damageDocFile3: image, damageDocName3: file[0]['name'].toString() })
                        }
                    }
                    else if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
                        image = await this.onPdfSelect(file[0]);
                        if (num == 1) {
                            this.setState({ damageDocFile1: image, damageDocName1: file[0]['name'].toString() })
                        } else if (num == 2) {
                            image = await this.resizeFile(file[0]);
                            this.setState({ damageDocFile2: image, damageDocName2: file[0]['name'].toString() })
                        } else if (num == 3) {
                            image = await this.resizeFile(file[0]);
                            this.setState({ damageDocFile3: image, damageDocName3: file[0]['name'].toString() })
                        }
                    }
                    var fileType = file[0]['type']
                    var fileTypeList;
                    if (fileType.includes("/")) {
                        fileTypeList = fileType.split("/")

                    }
                    if (num == 1) {
                        // this.setState({ damageDocFile1: image, damageDocName1: file[0]['name'].toString() })
                        this.setState({ damageDocType1: fileTypeList.length > 0 ? fileTypeList[1] : "", damageDocErr: '', })
                    } else if (num == 2) {
                        // this.setState({ damageDocFile1: image, damageDocName1: file[0]['name'].toString() })
                        this.setState({ damageDocType2: fileTypeList.length > 0 ? fileTypeList[1] : "", damageDocErr: '', })
                    } else if (num == 3) {
                        // this.setState({ damageDocFile1: image, damageDocName1: file[0]['name'].toString() })
                        this.setState({ damageDocType3: fileTypeList.length > 0 ? fileTypeList[1] : "", damageDocErr: '', })
                    }
                } else {
                    toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')
                }
            }
        }
    }
    resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                600,
                'JPEG',
                80,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64",
                300,
                300,
            );
        });
    onPdfSelect = (file) =>
        new Promise((resolve) => {
            let base64;
            // FileReader function for read the file.
            let fileReader = new FileReader();
            // Onload of file read the file content
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                // Print data in console
                resolve(base64);
            };
            // Convert data to base64
            fileReader.readAsDataURL(file);
        });

    markAsDamage(isDamage, DamageStatusID) {
        const { isLoading, ExitNo, damageDocErr, damageDocFile1, ExhExitPassHdrID, damageDocFile2, damageDocFile3, damageDocName1, damageDocName2, damageDocName3, damageDocPath1, damageDocPath2, damageDocPath3, damageDocType1, damageDocType2, damageDocType3, damageRemark, HallId, ZoneId, isOpen, QrCodeImg, ExhRegistrationNo, ContractorCompanyName, CompanyName, isLastExitPass, vendorId, hallList, zoneList, accountExitPassList, currentPage, dismantlePop, exhID, damagePop } = this.state
        var Err = false
        var damagedocArr = []
        if (damagePop && isDamage) {
            if (damageRemark == '' || damageRemark == null) {
                this.setState({
                    remarkErr: 'Please enter Remark'
                })
                Err = true

            }
            if (damageDocFile1 != '' && damageDocFile1 != null) {
                damagedocArr.push({ damageDocPath: damageDocPath1, damageDocName: damageDocName1, damageDocFile: damageDocFile1, damageDocType: damageDocType1, Remark: damageRemark })
            }
            if (damageDocFile2 != '' && damageDocFile2 != null) {
                damagedocArr.push({ damageDocPath: damageDocPath2, damageDocName: damageDocName2, damageDocFile: damageDocFile2, damageDocType: damageDocType2, Remark: damageRemark })
            }
            if (damageDocFile3 != '' && damageDocFile3 != null) {
                damagedocArr.push({ damageDocPath: damageDocPath3, damageDocName: damageDocName3, damageDocFile: damageDocFile3, damageDocType: damageDocType3, Remark: damageRemark })
            }
            if (damagedocArr.length == 0) {
                this.setState({
                    damageDocErr: 'Please enter atleast 1 image'
                })
                Err = true
            }
        }
        if (Err) {
            toastError("Enter mandatory fields")
            return
        } else {
            this.setState({ isLoading: true, })
            this.props
                .insertDamage_action(exhID, vendorId, isDamage ? damagedocArr : [], ExhExitPassHdrID, isLastExitPass, this.state.mailData, DamageStatusID)
                .then((data) => {
                    if (data.error != 1) {
                        this.setState({ dismantlePop: false, damagePop: false })
                        this.setState({
                            damageDocPath1: '',
                            damageDocName1: '',
                            damageDocFile1: '',
                            damageDocType1: '',
                            damageRemark: '',
                            damageDocPath2: '',
                            damageDocName2: '',
                            damageDocFile2: '',
                            damageDocType2: '',
                            damageDocType3: '',
                            damageDocName3: '',
                            damageDocFile3: '',
                            damageDocType3: '',
                        })
                        toastSuccess("Updated successfully")
                        this.getAccountExitPassList(1, 0)
                    }
                }).catch((e) => {
                    console.log(e);
                });
        }
    }

    updateDamageApproveStatus() {
        const { ExhExitPassHdrID, DamageStatusID, DamageApprovedRemark } = this.state
        if (DamageApprovedRemark?.trim() != '' && DamageApprovedRemark != null) {
            this.setState({ isLoading: true, })
            this.props
                .updateDamageApproveStatus_action(ExhExitPassHdrID, 4, DamageApprovedRemark)
                .then((data) => {
                    if (data.error != 1) {
                        this.setState({ isLoading: false, DamageStatusID: 1, DamageStatusPop: false })
                        toastSuccess("Damage Approved mark successfully")
                        this.getAccountExitPassList(1, 0)
                    }
                    this.setState({ isLoading: false, })
                }).catch((e) => {
                    console.log(e);
                });

        } else {
            toastError("Please enter remark")
            this.setState({ DamageApprovedRemarkErr: 'Please enter remark', DamageApprovedRemark: '' })
        }
    }

    onDismantleStall() {
        const { ExhExitPassHdrID, vendorId, exhID } = this.state

        this.setState({ isLoading: true, })
        this.props
            .dismantleStallHM_action(exhID, vendorId, [], ExhExitPassHdrID)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false, dismantlePop: false, damagePop: false })
                    toastSuccess("Tagged dismantled successfully")
                    this.getAccountExitPassList(1, 0)
                }
                this.setState({ isLoading: false, })
            }).catch((e) => {
                console.log(e);
            });
    }

    getWriteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '40');
        if (moduleAccess) {
            return moduleAccess.WriteAccess;
        } else {
            return false
        }
        return false;
    }

    getUpdateAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '40');
        if (moduleAccess) {
            return moduleAccess.UpdateAccess;
        } else {
            return false
        }
        return false;
    }

    getDeleteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '40');
        if (moduleAccess) {
            return moduleAccess.DeleteAccess;
        } else {
            return false
        }
        return false;
    }

    getDownloadAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '40');
        if (moduleAccess) {
            return moduleAccess.DownloadAccess;
        } else {
            return false
        }
        return false;
    }

    getSendAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '40');
        if (moduleAccess) {
            return moduleAccess.SendAccess;
        } else {
            return false
        }
        return false;
    }


    getSpecialAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '40');
        if (moduleAccess) {
            return moduleAccess.Is_SpecialAccess;
        } else {
            return false
        }
        return false;
    }

    render() {
        const { isLoading, NDRpop, NDR, ExitNo, damagePop, isLastExitPassPop, HallId, ZoneId, isOpen, QrCodeImg, ExhRegistrationNo, ContractorCompanyName, CompanyName, hallList, zoneList, accountExitPassList, currentPage, damageDocPath1, damageDocName1, damageDocFile1, damageDocType1, damageDocPath2, damageDocName2, damageDocFile2, damageDocType2, damageDocPath3, isImageModal, isOpenConfirmationModal, damageDocName3, remarkErr, damageDocFile3, imgarr, damageDocType3, damageDocErr, DamageStatusPop, DamageStatusID, DamageApprovedRemark, DamageApprovedRemarkErr, dismantlePop, isHallManager, IsDismantledPopDisable } = this.state
        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = accountExitPassList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(accountExitPassList.length / recordsPerPage)
        return (
            <>

                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}

                <ToastContainer />
                {/* <HeaderWithLogo /> */}
                <>
                    {!isHallManager &&
                        <>
                            <HeaderWithLogo />
                            <AdminDrawer />
                        </>
                    }
                    {/* <div className="app-content with-dr-container com-height"> */}
                    <div className={isHallManager ? "main-container" : "main-container with-dr-container"}>
                        {!isHallManager &&
                            <div className="row m-0">
                                <div className="breadcrumb-scroll-fixed">
                                    <h6 className="mb-0 p-2 text-white">Material Exit pass</h6>
                                </div>
                            </div>
                        }
                        <div className="admin-top-space p-2 pt-0">
                            <main id="main">
                                <section class="section p-0" >
                                    <div class="row m-0">

                                        <form>
                                            <div className="main-container p-2">
                                                <div className="row ">
                                                    <div className="col-xl-2 mb-3">
                                                        <label class="">Exit No</label>
                                                        <input type="text" class="form-control form-control-sm w-100" value={ExitNo} onChange={(e) => this.setState({ ExitNo: e.target.value })} />
                                                    </div>

                                                    <div className="col-xl-2 mb-3">
                                                        <label >Hall</label>
                                                        <select
                                                            className="form-control form-control-sm w-100"
                                                            id="roledb"
                                                            style={{ textAlign: "left" }}
                                                            value={HallId}
                                                            // disabled={isView || isReadOnly}
                                                            onChange={(e) => this.setState({ HallId: e.target.value })}
                                                        >
                                                            <option value="">Select</option>
                                                            {hallList.length > 0 && hallList.map((data) => (
                                                                <option key={data.HallId} value={data.HallId}>{data.HallName}</option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    <div className="col-xl-2 mb-3">
                                                        <label >Zone</label>
                                                        <select
                                                            className="form-control form-control-sm w-100"
                                                            id="roledb"
                                                            style={{ textAlign: "left" }}
                                                            value={ZoneId}
                                                            // disabled={isView || isReadOnly}
                                                            onChange={(e) => this.setState({ ZoneId: e.target.value })}
                                                        >
                                                            <option value="">Select</option>
                                                            {zoneList.length > 0 && zoneList.map((data) => (
                                                                <option key={data.ZoneID} value={data.ZoneID}>{data.Zone}</option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    <div className="col-xl-2 mb-3">
                                                        <label >Exhibitor Reg. No.</label>
                                                        <input type="text" class="form-control form-control-sm w-100" value={ExhRegistrationNo} onChange={(e) => this.setState({ ExhRegistrationNo: e.target.value })} />
                                                    </div>

                                                    <div className="col-xl-2 mb-3">
                                                        <label >Exhibitor</label>
                                                        <input type="text" class="form-control form-control-sm w-100" value={CompanyName} onChange={(e) => this.setState({ CompanyName: e.target.value })} />
                                                    </div>

                                                    <div className="col-xl-2 mb-3">
                                                        <label >Contractor</label>
                                                        <input type="text" class="form-control form-control-sm w-100" value={ContractorCompanyName} onChange={(e) => this.setState({ ContractorCompanyName: e.target.value })} />
                                                    </div>
                                                </div>

                                                <div className="d-flex justify-content-end">
                                                    <div className="d-flex gap-2" role="group" aria-label="Basic example">
                                                        <button
                                                            type="button"
                                                            class="btn btn-aqua"
                                                            onClick={(e) => this.getAccountExitPassList(1, 0)}>
                                                            Search
                                                        </button>
                                                        <button
                                                            type="button"
                                                            class="btn btn-gray"
                                                            onClick={() => this.clearValue()}>
                                                            Clear
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-end align-items-center w-100 mb-1">
                                                {this.state.statusList.length > 0 &&
                                                    <div class="d-flex align-items-center gap-1">

                                                        {this.state.statusList.map((item) => (
                                                            <div class="p-1 rounded-1 status-btn mb-2" onClick={() => this.getAccountExitPassList(item.DamageStatusID)} style={{ cursor: 'pointer' }} >
                                                                <i class={`${item.DamageStatusID == 1 ? "fa fa-hourglass-half" : item.DamageStatusID == 2 ? "bi bi-clipboard-check-fill" : item.DamageStatusID == 3 ? "bi bi-exclamation-triangle-fill" : item.DamageStatusID == 4 ? "fa fa-check-circle" : "fa fa-floppy-o"}  me-1 fs-6 status-name`}></i>
                                                                <span class=" status-name">{item.DamageName}</span>
                                                                <strong class="ms-1  status-name">{item.TotalCount}</strong>
                                                            </div>
                                                        ))}

                                                        <div onClick={() => this.onFilterClick(0)} class="p-1 rounded-1 status-btn mb-2">
                                                            <i class="bi bi-clock fs-7 status-name"></i>  &nbsp;
                                                            <span class="">Pending for Dismantle</span>
                                                            <strong class="ms-1 status-name">{this.state.tpending}</strong>
                                                        </div>

                                                        <div style={{ cursor: 'pointer' }}
                                                            class="p-1 rounded-1 status-btn mb-2" onClick={() => this.onFilterClick(1)}>
                                                            <i class="bi bi-tools fs-7 status-name"></i>  &nbsp;
                                                            <span class="">Dismantled</span>
                                                            <strong class="ms-1 status-name">{this.state.tcomp}</strong>
                                                        </div>


                                                        {/* <div class="p-1 rounded-1 status-btn mb-2" onClick={() => this.onFilterClick(3)} style={{ cursor: 'pointer' }} >
                                                        <i class="bi bi-exclamation-triangle-fill  me-1 fs-6"></i>
                                                        <span class=" status-name">Rejected</span>
                                                        <strong class="ms-1  status-name">{this.state.rejectedCount}</strong>
                                                    </div>

                                                    <div class="p-1 rounded-1 status-btn mb-2" onClick={() => this.onFilterClick(0)} style={{ cursor: 'pointer' }}>
                                                        <i class="bi bi-hourglass-split me-1 fs-6"></i>
                                                        <span class=" status-name">Pending:</span>
                                                        <strong class="ms-1 status-name">{this.state.pendingCount}</strong>
                                                    </div>

                                                    <div class="p-1 rounded-1 status-btn mb-2" onClick={() => this.onFilterClick(2)} style={{ cursor: 'pointer' }}>
                                                        <i class="bi bi-check-circle-fill fs-6 me-1"></i>
                                                        <span class=" status-name">Approved:</span>
                                                        <strong class="ms-1 status-name">{this.state.approvedCount}</strong>
                                                    </div> */}
                                                    </div>
                                                }
                                            </div>
                                            <div class="table-responsive px-1 sticky-table-wrapper service-list-grid">

                                                {this.renderList(accountExitPassList.length > 0 ? currentRecords : [])}
                                                {/* //here */}
                                            </div>
                                            <div class="mt-2 float-left trp">
                                                {
                                                    accountExitPassList.length > 0 ?
                                                        <Pagination
                                                            nPages={nPages}
                                                            currentPage={currentPage}
                                                            setCurrentPage={this.updateItem}
                                                        /> : <></>
                                                }
                                                <div class="table-record-pages">
                                                    Page {currentPage} of {nPages}
                                                </div>
                                            </div>
                                        </form>

                                    </div>
                                </section>
                            </main>
                        </div>
                        <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                            <div className="modal-dialog">
                                <div className="modal-content confirm-logout">
                                    <div class="modal-header p-2">
                                        <h5 class="modal-title modal_title_text text-white">Scan below QR in Kiosk Device for print Material Exit pass</h5>
                                        {/* <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isOpen: false })} style={{ background: '#eeeeee' }}><span aria-hidden="true" class="pop-cancel">&times;</span></button> */}
                                    </div>
                                    <div class="modal-body">
                                        <div class="row">
                                            <div class="col-md-12 text-center">
                                                <img
                                                    src={QrCodeImg}
                                                    alt="QR Code"
                                                    className="rounded-2xl shadow-lg w-64 h-64 object-contain"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer p-1">
                                        <div class="form-group text-right mod-fot">
                                            <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ isOpen: false })}>Close</button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </Modal>
                        <Modal isOpen={isLastExitPassPop} onRequestClose={() => this.setState({ isLastExitPassPop: false })}>
                            <div className="modal-dialog">
                                <div className="modal-content confirm-logout">
                                    <div class="modal-header bg-danger text-white py-2">
                                        <h5 class="modal-title" style={{ fontSize: "16px" }}>Last ExitPass</h5>
                                        <button type="button" class="btn-close btn-close-white text-white" onClick={() => this.setState({ isLastExitPassPop: false })} ></button>
                                    </div>
                                    <div class="modal-body">
                                        Is this the Last Material Exit pass?
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-gray bg-secondary" onClick={() => this.setState({ isLastExitPassPop: false, isLastExitPass: true, damagePop: true })}>Yes</button>
                                        <button type="button" class="btn btn-gray bg-secondary" onClick={() => this.setState({ isLastExitPassPop: false, isLastExitPass: false, damagePop: true })}>No</button>
                                        {/* <button type="button" class="btn btn-danger" onClick={() => this.onDismantleStall()}>Yes</button> */}
                                    </div>
                                </div>
                            </div>
                        </Modal>
                        <Modal
                            isOpen={this.state.damagePop} onRequestClose={() => this.setState({ damagePop: false })}
                        >
                            {/* <div className="modal-dialog">
                                                                  <div className="modal-content confirm-logout">
                                                                      <div class="modal-header p-2">
                                                                          <h5 class="modal-title">Additional Furniture</h5>
                                                                          <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isOpen: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                                                                      </div>
                                                                      <div>
                                                                      </div>
                                          
                                                                  </div>
                                                              </div> */}

                            {/* <div className="modal-dialog modal-xl modal-dialog-centered" style={{ marginLeft: '325px', marginTop: '60px' }}> */}

                            <div class="modal-dialog modal-xl modal-dialog-centered">
                                <div className="modal-content shadow-lg border-0 rounded-4">
                                    <div class="modal-header bg-danger text-white py-2">
                                        <h5 class="modal-title" style={{ fontSize: "16px" }}>Damaged Record</h5>
                                        <button type="button" class="btn-close btn-close-white text-white" onClick={() => this.setState({ damagePop: false })} ></button>
                                    </div>
                                    <div class="modal-body">
                                        <div>
                                            Do you want to tag this stall as <strong>Damaged?</strong>
                                        </div>
                                        <div class="mb-2">
                                            <label class="col-form-label">Remark<span class="text-danger">*</span></label>
                                            <textarea
                                                style={{ height: '100px !important' }}
                                                id="damageRemark"
                                                class="form-control"
                                                rows="4"
                                                placeholder="Enter reason here..."
                                                onChange={(e) =>
                                                    this.setState({ damageRemark: e.target.value, remarkErr: "" })
                                                }
                                                value={this.state.damageRemark}
                                            ></textarea>
                                            <span className="text-danger text-start text-left d-block mt-1">
                                                {remarkErr}
                                            </span>
                                        </div>
                                        <div className='mb-1'>
                                           <strong> Note: While taking pictures, please make sure that the booth name is clearly included and visible in photo.</strong>
                                            < br />
                                        </div>
                                        <div class="card-body border rounded p-2">
                                            <div class="row g-2 align-items-center">
                                                <div class="col-md-6">
                                                    <label class="form-label mb-1">Capture / Upload Photo of damage 1</label>
                                                    {damageDocName1 != null && damageDocName1 != '' ? <div style={{
                                                        border: '1px solid #ccc',
                                                        padding: '10px',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                    }}>
                                                        <a
                                                            href={damageDocPath1}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            {damageDocType1 != null && damageDocType1 != '' ? <span onClick={() => this.renderNewImage(damageDocFile1, damageDocType1)} style={{ marginRight: '10px', cursor: 'pointer' }}
                                                            >{damageDocName1}</span> : <span style={{ marginRight: '10px' }}
                                                            >{damageDocName1}</span>}
                                                        </a>
                                                        {<i className={`fa fa-times text-danger img-can`}
                                                            onClick={(e) => this.setState({ damageDocFile1: '', damageDocType1: '', damageDocName1: '', damageDocPath1: '' })}
                                                        ></i>}
                                                    </div>
                                                        : <div class="d-flex align-items-center gap-2">
                                                            {<button class="btn btn-aqua d-flex align-items-center" style={{ height: '27px' }} onClick={() => this.setState({ isImageModal: true, camNp: 1 })}>
                                                                <i class="bi bi-camera"></i> Open Camera
                                                            </button>}
                                                            {<span class="text-muted">or</span>}
                                                            {<div className="upload-options">
                                                                <label style={{ display: 'flex', margin: 0 }}>
                                                                    <input
                                                                        type="file"
                                                                        id='fileDoc1'
                                                                        ref='fileDoc1'
                                                                        name='fileDoc1'
                                                                        className="image-upload"
                                                                        accept=".jpg, .jpeg, .png, .pdf"
                                                                        onChange={e => this.onFilePick(e, e.target.files, 1)}
                                                                    />
                                                                </label>
                                                            </div>}
                                                        </div>}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-body border rounded p-2">
                                            <div class="row g-2 align-items-center">
                                                <div class="col-md-6">
                                                    <label class="form-label mb-1">Capture / Upload Photo of damage 2</label>
                                                    {damageDocName2 != null && damageDocName2 != '' ? <div style={{
                                                        border: '1px solid #ccc',
                                                        padding: '10px',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                    }}>
                                                        <a
                                                            href={damageDocPath2}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            {damageDocType2 != null && damageDocType2 != '' ? <span onClick={() => this.renderNewImage(damageDocFile2, damageDocType2)} style={{ marginRight: '10px', cursor: 'pointer' }}
                                                            >{damageDocName2}</span> : <span style={{ marginRight: '10px' }}
                                                            >{damageDocName2}</span>}
                                                        </a>
                                                        {<i className={`fa fa-times text-danger img-can`}
                                                            onClick={(e) => this.setState({ damageDocFile2: '', damageDocType2: '', damageDocName2: '', damageDocPath2: '' })}
                                                        ></i>}
                                                    </div>
                                                        : <div class="d-flex align-items-center gap-2">
                                                            {<button class="btn btn-aqua d-flex align-items-center" style={{ height: '27px' }} onClick={() => this.setState({ isImageModal: true, camNp: 2 })}>
                                                                <i class="bi bi-camera"></i> Open Camera
                                                            </button>}
                                                            {<span class="text-muted">or</span>}
                                                            {<div className="upload-options">
                                                                <label style={{ display: 'flex', margin: 0 }}>
                                                                    <input
                                                                        type="file"
                                                                        id='fileDoc1'
                                                                        ref='fileDoc1'
                                                                        name='fileDoc1'
                                                                        className="image-upload"
                                                                        accept=".jpg, .jpeg, .png, .pdf"
                                                                        onChange={e => this.onFilePick(e, e.target.files, 2)}
                                                                    />
                                                                </label>
                                                            </div>}
                                                        </div>}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-body border rounded p-2">
                                            <div class="row g-2 align-items-center">
                                                <div class="col-md-6">
                                                    <label class="form-label mb-1">Capture / Upload Photo of damage 3</label>
                                                    {damageDocName3 != null && damageDocName3 != '' ? <div style={{
                                                        border: '1px solid #ccc',
                                                        padding: '10px',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                    }}>
                                                        <a
                                                            href={damageDocPath3}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            {damageDocType3 != null && damageDocType3 != '' ? <span onClick={() => this.renderNewImage(damageDocFile3, damageDocType3)} style={{ marginRight: '10px', cursor: 'pointer' }}
                                                            >{damageDocName3}</span> : <span style={{ marginRight: '10px' }}
                                                            >{damageDocName3}</span>}
                                                        </a>
                                                        {<i className={`fa fa-times text-danger img-can`}
                                                            onClick={(e) => this.setState({ damageDocFile3: '', damageDocType3: '', damageDocName3: '', damageDocPath3: '' })}
                                                        ></i>}
                                                    </div>
                                                        : <div class="d-flex align-items-center gap-2">
                                                            {<button class="btn btn-aqua d-flex align-items-center" style={{ height: '27px' }} onClick={() => this.setState({ isImageModal: true, camNp: 3 })}>
                                                                <i class="bi bi-camera"></i> Open Camera
                                                            </button>}
                                                            {<span class="text-muted">or</span>}
                                                            {<div className="upload-options">
                                                                <label style={{ display: 'flex', margin: 0 }}>
                                                                    <input
                                                                        type="file"
                                                                        id='fileDoc1'
                                                                        ref='fileDoc1'
                                                                        name='fileDoc1'
                                                                        className="image-upload"
                                                                        accept=".jpg, .jpeg, .png, .pdf"
                                                                        onChange={e => this.onFilePick(e, e.target.files, 3)}
                                                                    />
                                                                </label>
                                                            </div>}
                                                        </div>}
                                                </div>
                                            </div>
                                        </div>
                                        {/* <span className="text-danger text-start text-left d-block mt-1">
                                            {damageDocErr}
                                        </span> */}
                                        <span className="text-danger text-start text-left d-block mt-1">
                                            Please upload atleast 1 image
                                        </span>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-gray bg-secondary" onClick={() => this.setState({ damagePop: false })}>Cancel</button>
                                        <button type="button" class="btn  btn-gray bg-secondary" onClick={() => this.markAsDamage(0, 2)}>Submit without Damage</button>
                                        <button type="button" class="btn btn-danger" onClick={() => this.markAsDamage(1, 3)}>Submit Damage</button>
                                    </div>
                                </div>
                            </div>
                        </Modal><Modal
                            isOpen={this.state.damagePop2} onRequestClose={() => this.setState({ damagePop2: false })}
                        >
                            {/* <div className="modal-dialog">
                                                                                                      <div className="modal-content confirm-logout">
                                                                                                          <div class="modal-header p-2">
                                                                                                              <h5 class="modal-title">Additional Furniture</h5>
                                                                                                              <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isOpen: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                                                                                                          </div>
                                                                                                          <div>
                                                                                                          </div>
                                                                              
                                                                                                      </div>
                                                                                                  </div> */}

                            {/* <div className="modal-dialog modal-xl modal-dialog-centered" style={{ marginLeft: '325px', marginTop: '60px' }}> */}

                            <div class="modal-dialog modal-xl modal-dialog-centered" style={{ fontSize: 'larger' }}>
                                <div className="modal-content shadow-lg border-0 rounded-4">
                                    <div class="modal-header bg-danger text-white py-2">
                                        <h5 class="modal-title" style={{ fontSize: "16px" }}>Damaged Record</h5>
                                        <button type="button" class="btn-close btn-close-white text-white" onClick={() => this.setState({ damagePop2: false })} ></button>
                                    </div>
                                    <div class="modal-body">
                                        <div >
                                            <strong style={{ fontSize: 'x-large' }}>{this.state.exhNo}</strong><br />
                                            <strong>{this.state.exhname}</strong><br />
                                            <strong>{this.state.DmgCompanyName[0]}</strong><br />
                                        </div>
                                        <div>
                                            Damage Marked By: <strong>{this.state.damageMarked}</strong><br />
                                            Damage Marked Date: <strong>{moment(this.state.DamageDate).format('DD/MM/YYYY')}</strong><br /><br />
                                        </div>
                                        <div>
                                            Remark: <strong>{this.state.damageRemark}</strong><br />
                                        </div>
                                        <div>
                                            Images<br />
                                            {imgarr.length > 0 && imgarr.map(item => (
                                                <img
                                                    onClick={() => window.open(item, "_blank", "noopener,noreferrer")}
                                                    src={item}
                                                    style={{ margin: '2px', cursor: 'pointer' }}
                                                    alt="Preview"
                                                    width="200"
                                                    height="200"
                                                />
                                            ))}
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-gray bg-secondary" onClick={() => this.setState({ damagePop2: false })}>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </Modal>
                        <Modal
                            isOpen={NDRpop}
                            onRequestClose={() => this.setState({ NDRpop: false })}
                            shouldCloseOnEsc={true}
                            shouldCloseOnOverlayClick={true}
                            ariaHideApp={false}
                        >
                            <div className="modal-dialog modal-l">
                                <div className="modal-content">
                                    <div className="modal-header text-white">
                                        <h6 className="modal-title">No Due Remark</h6>
                                        <button type="button" className="btn-close btn-close-white" onClick={() => this.setState({ NDRpop: false })} />
                                    </div>

                                    {/* <div className="modal-body">{this.openModal(this.state.selectedServiceName)}</div> */}
                                    <div className="modal-body">
                                        {NDR}
                                    </div>
                                    {/* <div className="modal-body">{<BrandingOpportunity />}</div> */}
                                    <div className="modal-footer">
                                        <button className="btn btn-gray" onClick={() => this.setState({ NDRpop: false })}>
                                            Ok
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Modal>
                        <Modal
                            isOpen={DamageStatusPop}
                            onRequestClose={() => this.setState({ DamageStatusPop: false })}
                            shouldCloseOnEsc={true}
                            shouldCloseOnOverlayClick={true}
                            ariaHideApp={false}
                        >
                            <div className="modal-dialog modal-xl">
                                <div className="modal-content">
                                    <div className="modal-header text-white">
                                        <h6 className="modal-title">Approve Damage</h6>
                                        <button type="button" className="btn-close btn-close-white" onClick={() => this.setState({ DamageStatusPop: false, DamageApprovedRemark: '' })} />
                                    </div>
                                    <div className="modal-body">
                                        <div>
                                            <label class="col-form-label">Remark<span class="text-danger">*</span></label>
                                            <textarea
                                                style={{ height: '100px !important' }}
                                                class="form-control"
                                                rows="4"
                                                placeholder="Enter reason here..."
                                                onChange={(e) =>
                                                    this.setState({ DamageApprovedRemark: e.target.value, DamageApprovedRemarkErr: "" })
                                                }
                                                value={DamageApprovedRemark}
                                                disabled={IsDismantledPopDisable}
                                            ></textarea>
                                            <span className="text-danger text-start text-left d-block mt-1">
                                                {DamageApprovedRemarkErr}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        {!IsDismantledPopDisable ?
                                            <button className="btn btn-aqua" onClick={() => this.updateDamageApproveStatus()}>
                                                Approve
                                            </button> : ''
                                        }
                                        <button className="btn btn-gray" onClick={() => this.setState({ DamageStatusPop: false, DamageApprovedRemark: '' })}>
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Modal>

                        <Modal isOpen={dismantlePop} onRequestClose={() => this.setState({ dismantlePop: false })}>
                            <div className="modal-dialog">
                                <div className="modal-content confirm-logout">
                                    <div class="modal-header bg-danger text-white py-2">
                                        <h5 class="modal-title" style={{ fontSize: "16px" }}>Dismantled Record</h5>
                                        <button type="button" class="btn-close btn-close-white text-white" onClick={() => this.setState({ dismantlePop: false })} ></button>
                                    </div>
                                    <div class="modal-body">
                                        Do you want to tag this stall as <strong>Dismantled?</strong>
                                    </div>
                                    <div class="modal-footer">
                                        {/* <button type="button" class="btn btn-gray bg-secondary" onClick={() => this.setState({ dismantlePop: false, damagePop: true })}>Mark as Damaged</button> */}
                                        <button type="button" class="btn btn-gray bg-secondary" onClick={() => this.setState({ dismantlePop: false })}>No</button>
                                        <button type="button" class="btn btn-danger" onClick={() => this.onDismantleStall()}>Yes</button>
                                    </div>
                                </div>
                            </div>
                        </Modal>

                        <ImageCapture
                            isOpen={isImageModal}
                            onClose={() => this.setState({ isImageModal: false })}
                            onCapture={this.handleCapture}
                        />
                    </div>
                </>
            </>)
    }
}

export default withRouter(connect(null, {
    fill_action,
    getAccountExitPassList_action, insertExitPassOTP_action, verifyExitPassOTP_action, getExitPassPdf_action, insertDamage_action, getDamageDetails_action, updateDamageApproveStatus_action, dismantleStallHM_action
})(AccountExitPassList));